var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"data-assistant-page"},[_c('div',{staticClass:"data-assistant-page-section-l"},[_c('DataAssistant',{on:{"getTime":_vm.getTime}}),_c('DetailData',{attrs:{"startTime":_vm.startTime,"endTime":_vm.endTime}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }